export const plannedSection = {
  title: 'WHAT IF YOUR PRENATAL SESSIONS WERE ALREADY PLANNED?',
  lines: [
    'You don’t need another certification.',
    'You don’t need hundreds of random exercises.',
    'You don’t need to rebuild every session from scratch.',
  ],
  needLine: 'You need a system.',
  pillars: [
    'Assessment.',
    'Exercise selection.',
    'Adaptations.',
    'Ready-to-coach sessions.',
    'Programming.',
    'Client management.',
  ],
  close:
    'PRENATAL FITNESS COACH PRO™ gives you the complete professional system to plan, adapt, and deliver structured prenatal fitness coaching without starting from a blank page every week.',
}

export const painSection = {
  title: '😰 STOP SPENDING HOURS PREPARING EVERY SESSION',
  intro: ['Maybe you already know how to coach.', 'But then the planning begins.'],
  questions: [
    'Which exercises should you choose?',
    'What should you modify?',
    'How should the session progress?',
    'What if your client’s needs change?',
    'What if an exercise no longer works?',
    'How do you structure the next few weeks?',
    'How do you keep everything organized?',
    'How do you do all of this without spending hours preparing?',
  ],
  close: ['You don’t need more scattered information.', 'You need the complete system.'],
}

export const notEnoughSection = {
  title: '⚠️ KNOWING EXERCISES ISN’T ENOUGH',
  intro: [
    'Anyone can search for prenatal exercises online.',
    'But finding exercises and having a professional coaching system are two very different things.',
  ],
  needLabel: 'You need:',
  needs: [
    'assessment,',
    'exercise selection,',
    'adaptations,',
    'session structures,',
    'progressions,',
    'modifications,',
    'programming,',
    'client feedback,',
    'tracking,',
    'and organization.',
  ],
  close: [
    'Because your client shouldn’t receive a workout you put together five minutes before the session.',
    'She should receive structured professional coaching.',
  ],
}

export const transformSection = {
  title: '⏱️ TURN HOURS OF PLANNING INTO A READY-TO-USE SYSTEM',
  intro: 'Imagine opening one system and having what you need.',
  items: [
    'Client assessments.',
    'Exercise libraries.',
    'Modification options.',
    'Trimester adaptations.',
    'Complete sessions.',
    'Multi-week programs.',
    'Coaching tools.',
    'Professional templates.',
  ],
  close: [
    'Not another folder of random resources.',
    'One organized system you can actually use with your prenatal fitness clients.',
    'PRENATAL FITNESS COACH PRO™ brings the complete process together.',
  ],
}

export const objectionSection = {
  title: 'YOU DON’T NEED MORE MATERIAL SCATTERED ACROSS THE INTERNET',
  intro: 'You may be thinking:',
  thoughts: [
    '“I already know plenty of exercises.”',
    '“I already have a certification.”',
    '“I can create my own workouts.”',
    '“I’ve been coaching for years.”',
  ],
  mid: [
    'Exactly.',
    'This isn’t about teaching you how to become a coach.',
    'It’s about giving you the system.',
  ],
  steps: [
    'Assess the client.',
    'Choose the exercises.',
    'Adapt the session.',
    'Build the program.',
    'Track what happens.',
  ],
  close: 'You bring the coaching experience. We give you the ready-to-use structure.',
}

export const beforeAfterSection = {
  title: 'FROM A BLANK PAGE TO A COMPLETE COACHING SYSTEM',
  intro: 'Think about the transformation.',
  today: [
    'Exercises saved everywhere.',
    'Sessions built from scratch.',
    'Notes scattered across different files.',
    'Constantly deciding what to modify.',
  ],
  tomorrow: [
    'Your assessment system.',
    'Your exercise library.',
    'Your ready-to-coach sessions.',
    'Your programming framework.',
    'Your modification resources.',
    'Your client management tools.',
  ],
  close: [
    'One complete professional system.',
    'That’s what PRENATAL FITNESS COACH PRO™ is designed to give you.',
  ],
}

export const systemIntro = [
  'Not a random exercise collection.',
  'Not another basic fitness ebook.',
  'Not endless theory.',
  'A complete practical system designed to take you from “I need to plan another session” to “I already have the system to build it.”',
]

export const promises = [
  'Assess and organize every client',
  'Access a structured exercise library',
  'Adapt training as needs change',
  'Use complete ready-to-coach sessions',
  'Build structured multi-week programs',
  'Manage clients with professional tools',
]

export const finalSection = {
  title: 'ONE LAST QUESTION',
  lead: 'How many hours have you already spent planning sessions from scratch?',
  lines: [
    'Another week can pass.',
    'Another month can pass.',
    'You can keep searching for exercises.',
    'Keep rebuilding sessions.',
    'Keep creating new templates.',
    'Keep wondering what you’ll coach next.',
  ],
  pivot: 'Or you can open one complete system:',
  system: 'Assess. Select. Adapt. Coach.',
  actions: ['Plan it.', 'Deliver it.', 'Track it.', 'Improve it.'],
  close: 'And spend more of your time actually coaching.',
}
